import { createGlobalStyle } from "styled-components";

export const ThemeCssVariables = createGlobalStyle`
  :root {
    /* Base colors */
    --background: 0 0% 100%;
    --foreground: 222.2 84% 4.9%;
    
    --card: 0 0% 100%;
    --card-foreground: 222.2 84% 4.9%;
    
    --popover: 0 0% 100%;
    --popover-foreground: 222.2 84% 4.9%;
    
    --primary: 215 100% 30%;
    --primary-foreground: 0 0% 100%;
    
    --secondary: 210 40% 96.1%;
    --secondary-foreground: 222.2 47.4% 11.2%;
    
    --muted: 210 40% 96.1%;
    --muted-foreground: 215.4 16.3% 46.9%;
    
    --accent: 210 40% 96.1%;
    --accent-foreground: 222.2 47.4% 11.2%;
    
    --destructive: 0 84.2% 60.2%;
    --destructive-foreground: 210 40% 98%;

    --success: 142.1 76.2% 36.3%;
    --success-foreground: 355.7 100% 97.3%;
    
    --warning: 38 92% 50%;
    --warning-foreground: 48 96% 89%;
    
    --info: 215 100% 30%;
    --info-foreground: 0 0% 100%;
    
    --border: 214.3 31.8% 91.4%;
    --input: 214.3 31.8% 91.4%;
    --ring: 221.2 83.2% 53.3%;
    
    /* Primary color shades - Ink Blue */
    --primary-50: 215 100% 97%;
    --primary-100: 215 100% 95%;
    --primary-200: 215 100% 90%;
    --primary-300: 215 100% 80%;
    --primary-400: 215 100% 60%;
    --primary-500: 215 100% 45%;
    --primary-600: 215 100% 35%;
    --primary-700: 215 100% 30%;
    --primary-800: 215 100% 25%;
    --primary-900: 215 100% 20%;
    --primary-950: 215 100% 15%;
    
    /* Secondary color shades */
    --secondary-50: 210 40% 98%;
    --secondary-100: 210 40% 96.1%;
    --secondary-200: 214 32% 91%;
    --secondary-300: 213 27% 84%;
    --secondary-400: 215 20% 65%;
    --secondary-500: 215 16% 47%;
    --secondary-600: 215 19% 35%;
    --secondary-700: 215 25% 27%;
    --secondary-800: 217 33% 17%;
    --secondary-900: 222 47% 11%;
    --secondary-950: 229 84% 5%;
    
    /* Accent color shades */
    --accent-50: 210 40% 98%;
    --accent-100: 210 40% 96.1%;
    --accent-200: 214 32% 91%;
    --accent-300: 213 27% 84%;
    --accent-400: 215 20% 65%;
    --accent-500: 215 16% 47%;
    --accent-600: 215 19% 35%;
    --accent-700: 215 25% 27%;
    --accent-800: 217 33% 17%;
    --accent-900: 222 47% 11%;
    --accent-950: 229 84% 5%;
    
    /* Success color shades */
    --success-50: 138 76% 97%;
    --success-100: 141 84% 93%;
    --success-200: 141 79% 85%;
    --success-300: 142 77% 73%;
    --success-400: 142 69% 58%;
    --success-500: 142.1 76.2% 36.3%;
    --success-600: 142 72% 29%;
    --success-700: 142 76% 24%;
    --success-800: 143 64% 24%;
    --success-900: 144 61% 20%;
    --success-950: 145 80% 10%;
    
    /* Warning color shades */
    --warning-50: 48 100% 96%;
    --warning-100: 48 96% 89%;
    --warning-200: 48 97% 77%;
    --warning-300: 46 97% 65%;
    --warning-400: 43 96% 56%;
    --warning-500: 38 92% 50%;
    --warning-600: 32 95% 44%;
    --warning-700: 26 90% 37%;
    --warning-800: 23 83% 31%;
    --warning-900: 22 78% 26%;
    --warning-950: 21 92% 14%;
    
    /* Destructive color shades */
    --destructive-50: 0 86% 97%;
    --destructive-100: 0 93% 94%;
    --destructive-200: 0 96% 89%;
    --destructive-300: 0 94% 82%;
    --destructive-400: 0 91% 71%;
    --destructive-500: 0 84.2% 60.2%;
    --destructive-600: 0 72% 51%;
    --destructive-700: 0 74% 42%;
    --destructive-800: 0 70% 35%;
    --destructive-900: 0 63% 31%;
    --destructive-950: 0 58% 17%;
    
    /* Info color shades - matching primary ink blue */
    --info-50: 215 100% 97%;
    --info-100: 215 100% 95%;
    --info-200: 215 100% 90%;
    --info-300: 215 100% 80%;
    --info-400: 215 100% 60%;
    --info-500: 215 100% 45%;
    --info-600: 215 100% 35%;
    --info-700: 215 100% 30%;
    --info-800: 215 100% 25%;
    --info-900: 215 100% 20%;
    --info-950: 215 100% 15%;
    
    /* Chart colors */
    --chart-1: 215 100% 30%;
    --chart-2: 142.1 76.2% 36.3%;
    --chart-3: 38 92% 50%;
    --chart-4: 0 84.2% 60.2%;
    --chart-5: 262 83% 58%;
    
    /* Radius */
    --radius: 0.5rem;
  }

  .dark {
    --background: 222.2 84% 4.9%;
    --foreground: 210 40% 98%;
    
    --card: 222.2 84% 4.9%;
    --card-foreground: 210 40% 98%;
    
    --popover: 222.2 84% 4.9%;
    --popover-foreground: 210 40% 98%;
    
    --primary: 215 100% 45%;
    --primary-foreground: 0 0% 100%;
    
    --secondary: 217.2 32.6% 17.5%;
    --secondary-foreground: 210 40% 98%;
    
    --muted: 217.2 32.6% 17.5%;
    --muted-foreground: 215 20.2% 65.1%;
    
    --accent: 217.2 32.6% 17.5%;
    --accent-foreground: 210 40% 98%;
    
    --destructive: 0 62.8% 30.6%;
    --destructive-foreground: 210 40% 98%;
    
    --success: 142.1 70.6% 45.3%;
    --success-foreground: 144.9 80.4% 10%;
    
    --warning: 48 96% 89%;
    --warning-foreground: 38 92% 50%;
    
    --info: 215 100% 45%;
    --info-foreground: 0 0% 100%;
    
    --border: 217.2 32.6% 17.5%;
    --input: 217.2 32.6% 17.5%;
    --ring: 224.3 76.3% 48%;
    
    /* Primary color shades - dark mode */
    --primary-50: 215 100% 97%;
    --primary-100: 215 100% 95%;
    --primary-200: 215 100% 90%;
    --primary-300: 215 100% 85%;
    --primary-400: 215 100% 70%;
    --primary-500: 215 100% 55%;
    --primary-600: 215 100% 50%;
    --primary-700: 215 100% 45%;
    --primary-800: 215 100% 40%;
    --primary-900: 215 100% 35%;
    --primary-950: 215 100% 25%;
    
    /* Secondary color shades - dark mode */
    --secondary-50: 210 40% 98%;
    --secondary-100: 217.9 10.6% 64.9%;
    --secondary-200: 215 20.2% 65.1%;
    --secondary-300: 215.3 19.3% 56.9%;
    --secondary-400: 215.4 16.3% 46.9%;
    --secondary-500: 215.3 19.3% 34.5%;
    --secondary-600: 215.4 25% 26.7%;
    --secondary-700: 217.2 32.6% 17.5%;
    --secondary-800: 222.2 47.4% 11.2%;
    --secondary-900: 224.3 57.9% 9.8%;
    --secondary-950: 226.2 57.3% 5%;
    
    /* Chart colors - dark mode */
    --chart-1: 215 100% 55%;
    --chart-2: 142.1 70.6% 45.3%;
    --chart-3: 48 96% 89%;
    --chart-4: 0 62.8% 30.6%;
    --chart-5: 262 83% 68%;
  }
`;

export default ThemeCssVariables;
